import Helpers from '../mixins/Helpers';

export const GRANDPARENT_CLASSIFICATIONS = {
	INCOME: 0,
	FUTURE_PLANNING: 1,
	EVERYDAY_SPEND: 2,
	FIXED_COSTS: 3
};

export default {
	mixins: [Helpers],
	data() {
		return {
			breadCrumb: [],
			showMerchantTransactions: false,
			showPlanManagement: false,
			selectedClassificationSpend: 0,
			selectedClassificationIncome: 0,
			categoryWellData: [],
		}
	},

	created: function() {
		this.bounce();
	},

	computed: {
		_drawerTitle() {
			if (this.showMerchantTransactions) {
				return this.merchantTransactions.length > 0 ? this.merchantTransactions[0][0].merchantName : '';
			}
			return this.selectedClassification ? this.selectedClassification.fullName : '';
		}
	},

	methods: {
		_findClassificationByName: function(name, classifications, returnParent = false) {
			for (const classification of classifications) {
				if (classification.mgClassification.mgClassification == name) {
					return classification;
				}
				if (classification.children && classification.children.length > 0) {
					const foundClassification = this._findClassificationByName(name, classification.children);
					if (foundClassification) {
						if (returnParent) {
							return classification;
						}
						return foundClassification;
					}
				}
			}
			return null;
		},

		_findClassificationById: function(id, classifications, returnParent = false) {
			for (const classification of classifications) {
				if (classification.mgClassification.id === id) {
					return classification;
				}
				if (classification.children && classification.children.length > 0) {
					const foundClassification = this._findClassificationById(id, classification.children);
					if (foundClassification) {
						if (returnParent) {
							return classification;
						}
						return foundClassification;
					}
				}
			}
			return null;
		},

		_findClassificationsByGrandparentClassification: function(grandParentClassification, classifications) {
			const result = [];
			for (const classification of classifications) {
				if (classification.mgClassification.grandParentClassification === grandParentClassification) {
					result.push(classification);
				}
				if (classification.children && classification.children.length > 0) {
					const foundClassifications = this._findClassificationsByGrandparentClassification(grandParentClassification, classification.children);
					if (foundClassifications) {
						result.push(...foundClassifications);
					}
				}
			}
			return result;
		},
		
		_navigateToPlan(classification) {
			this.showPlanManagement = true;
			this.closeDrawerNext = false;
			var plan = this.spendingPlansFull.plans.find(p => p.classification.id === classification.id);

			if (!plan || !plan.plan) {
				plan = {
					classification: classification,
					plan: {
						amount: 0
					},
					avgNetSpend: 0,
					avgTransactionCount: 0
				};
				this._createPlan(plan);
				if (this.resetSections) {
					this.resetSections();
				}
			} else {
				this._createPlan(plan);
				if (this._setFieldValue && plan.plan) {
					this._setFieldValue('Plan amount', plan.plan.amount);
				}
				if (this.sections && this.sections.length > 0 && this.sections[0].fields) {
					this.sections = [
						{
							fields: [
								{
									label: 'Plan amount',
									type: 'currency',
									value: plan.plan ? plan.plan.amount : null,
									required: true
								}
							]
						},
					];
				}
			}
		},

		_handleDrawerClosed() {
			this.merchantTransactions = [];
			this.categoryWellData = [];
			this.selectedClassification = null;
			this.showMerchantTransactions = false;
			this.selectedClassificationPlanAmount = 0;
			this.showPlanManagement = false;
		},

		_handleMerchantClicked(merchant) {
			this.merchantTransactions = [];
			var txns = this.transactions.transactions.filter(transaction => transaction.merchantName === merchant.label);

			// Group transactions by timestampString
			const groupedByTimestamp = txns.reduce((acc, transaction) => {
				const timestamp = transaction.timestampString || 'Unknown';
				if (!acc[timestamp]) {
					acc[timestamp] = [];
				}
				acc[timestamp].push(transaction);
				return acc;
			}, {});

			// Convert grouped transactions to an array of arrays
			this.merchantTransactions = Object.keys(groupedByTimestamp).map(timestamp => groupedByTimestamp[timestamp]);

			this.selectedMerchantSpend = this.merchantTransactions.reduce((total, transactions) => {
				return total + transactions.reduce((subTotal, transaction) => subTotal + transaction.amount, 0);
			}, 0);

			this.showMerchantTransactions = true;
			this.showPlanManagement = false;
			this.closeDrawerNext = false;
		},

		_handleCategoryClicked(classification, grandParentClassification) {
			var selectedSlot = this.slots.find(s => s.key === this.selectedSlotKey);
			this._getTransactions(classification.id, selectedSlot.from, selectedSlot.to, () => {
				this.groupedTransactions = this.transactions.transactions.reduce((acc, transaction) => {
					const merchantName = transaction.merchantName || 'Unknown';
					if (!acc[merchantName]) {
						acc[merchantName] = {
							merchantName: merchantName,
							totalAmount: 0,
							transactions: []
						};
					}
					acc[merchantName].totalAmount += transaction.amount;
					acc[merchantName].transactions.push(transaction);
					return acc;
				}, {});
				this.categoryWellData = [];
				if (Object.keys(this.groupedTransactions).length > 0) {
					Object.keys(this.groupedTransactions).forEach((merchantName, index) => {
						var count = this.groupedTransactions[merchantName].transactions.length;
						var totalamount = this.groupedTransactions[merchantName].transactions.reduce((total, transaction) => {
							return total + transaction.amount;
						}, 0);
						this.categoryWellData.push({
							order: index + 1,
							label: merchantName,
							value: this.formatter.format(Math.abs(Math.round(totalamount))),						
							supplement: (count > 1 ? ' (x' + count + ')': ''),
							moneyIn: totalamount > 0,
						});
					});
				}
				else {
					this.categoryWellData.push({
						label: 'No data',
						value: 0,
						supplement: '',
						moneyIn: false
					});
				}

			}, /* includeChildrenClassifications */ true, /* refreshCache */ false, /* includeExcludedFromAnalysis */ false);
			var selectedClassificationPlan = this.spendingPlans.plans.find(plan => plan.classification.id === classification.id);
			if (selectedClassificationPlan) {
				this.selectedClassificationPlanAmount = selectedClassificationPlan.plan.amount;
			}
			var categoryArray = [];
			this.allEveryDaySpend = this.spendingAnalysisStructured.grandparentAnalysis.filter(item => item.grandparent === GRANDPARENT_CLASSIFICATIONS.EVERYDAY_SPEND);
			this.allCommittedCosts = this.spendingAnalysisStructured.grandparentAnalysis.filter(item => item.grandparent === GRANDPARENT_CLASSIFICATIONS.FIXED_COSTS);
			this.allFuturePlans = this.spendingAnalysisStructured.grandparentAnalysis.filter(item => item.grandparent === GRANDPARENT_CLASSIFICATIONS.FUTURE_PLANNING);
			this.allIncome = this.spendingAnalysisStructured.grandparentAnalysis.filter(item => item.grandparent === GRANDPARENT_CLASSIFICATIONS.INCOME);

			if (grandParentClassification === GRANDPARENT_CLASSIFICATIONS.EVERYDAY_SPEND) {
				categoryArray = this.allEveryDaySpend;
			} else if (grandParentClassification === GRANDPARENT_CLASSIFICATIONS.FUTURE_PLANNING) {
				categoryArray = this.allFuturePlans;
			} else if (grandParentClassification === GRANDPARENT_CLASSIFICATIONS.FIXED_COSTS) {
				categoryArray = this.allCommittedCosts;
			} else if (grandParentClassification === GRANDPARENT_CLASSIFICATIONS.INCOME) {
				categoryArray = this.allIncome;
			}
			var selectedClassification = this.selectedCategory(categoryArray, grandParentClassification).groupedAnalysis.find(g => g.transactionClassification.id === classification.id);
			this.selectedClassificationSpend = selectedClassification.amountNet;
			this.selectedClassificationIncome = selectedClassification.amountIn;
			this.selectedClassification = classification;

			const classificationColours = {
				[GRANDPARENT_CLASSIFICATIONS.EVERYDAY_SPEND]: '#EEF0FF',
				[GRANDPARENT_CLASSIFICATIONS.FUTURE_PLANNING]: '#EFE8E6',
				[GRANDPARENT_CLASSIFICATIONS.FIXED_COSTS]: '#413655',
				[GRANDPARENT_CLASSIFICATIONS.INCOME]: '#B4D8D7'
			};
			this.selectedClassification.bgColour = classificationColours[this.selectedClassification.grandParentClassification];
			this.$refs.transactionDrawer.openDrawer();
		},

		selectedCategory(categoryArray, grandparentClassification) {
			var selected = categoryArray.find(s => s.slotName === this.selectedSlotKey) 
			if (!selected) {
				selected = {
					label: this.selectedSlotKey,
					totalIn: 0,
					totalOut: 0,
					totalNet: 0,
					groupedAnalysis: []
				};
			}
			// add any missing groups that we have plans for
			var newGroups = [];
			var plans = this.spendingPlans.plans.filter(plan => plan.classification.grandParentClassification === grandparentClassification);
			plans.forEach(plan => {
				// if this plan isn't found in the analysis, add it
				if (!selected.groupedAnalysis.find(g => g.name === plan.classification.fullName))
				{
					newGroups.push({
						name: plan.classification.fullName,
						transactionClassification: plan.classification,
						amountIn: 0,
						amountOut: 0,
						amountNet: 0,						
					});
				}
			});
			selected.groupedAnalysis = selected.groupedAnalysis.concat(newGroups);
			// sort the groups by amountOut (abs)
			selected.groupedAnalysis.sort((a, b) => Math.abs(b.amountNet) - Math.abs(a.amountNet));
			// If the groupedAnalysis.name is 'Uncategorised' then change then name to: 'Tag n transactions'.  Get n from groupedAnalysis.countNegativeTransactions
			selected.groupedAnalysis.forEach(group => 
				{
					if (group.name === 'Uncategorized') {
						group.name = 'Tag ' + group.countNegativeTransactions + ' transaction' + (group.countNegativeTransactions !== 1 ? 's' : '');
					}
				}
			);
			return selected;
		},
	}
}